import React from 'react'


const Overview = () => {
    return (
        <>
             <div className="plan welcome">
                    <div className="headerContainer primary">
                        <div>Welcome to OneProtection!</div>
                    </div>
                    <div className="infoContainer">
                        <div className="welcome-video">
                            <div className="embed-container">
                                <iframe 
                                    src="https://player.vimeo.com/video/478459750" 
                                    width="640" 
                                    height="360" 
                                    frameBorder="0" 
                                    allow="autoplay; fullscreen" 
                                    allowFullScreen
                                ></iframe>
                                <p>
                                    <a href="https://vimeo.com/478459750">OneProtection Intro Video</a> from <a href="https://vimeo.com/user126978502">One Protection</a> on <a href="https://vimeo.com">Vimeo</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    )
}

export default Overview
